import React from 'react';
import { useTranslation } from '../lib/i18n';
export function ReturnsRefundsPage() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  return <main className="min-h-screen bg-dark-bg pt-24 pb-16" data-id="element-995">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-996">
        <h1 className="text-3xl md:text-4xl font-black text-white mb-8" data-id="element-997">
          {en ? 'Return & Refund Policy' : ru ? 'Политика возврата' : 'Reklamacije i povraćaj'}
        </h1>
        <div className="prose prose-invert max-w-none text-gray-300 space-y-6" data-id="element-998">
          <p data-id="element-999">
            Kompanija DTECH ATLAS DOO posluje u skladu sa Zakonom o zaštiti
            potrošača Republike Srbije. Naš cilj je vaše potpuno zadovoljstvo
            kupljenom opremom.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1000">
            1. Pravo na odustanak od ugovora
          </h2>
          <p data-id="element-1001">
            Ukoliko ste robu kupili kao fizičko lice (potrošač) putem interneta
            (ugovor na daljinu), imate pravo da odustanete od ugovora u roku od
            14 dana od dana isporuke, bez navođenja razloga. Da biste ostvarili
            ovo pravo, morate nas obavestiti pisanim putem (na e-mail
            info@dtech.rs).
          </p>
          <p data-id="element-1002">
            U slučaju odustanka, dužni ste da robu vratite u originalnoj
            ambalaži, nekorišćenu i neoštećenu, o svom trošku. Povraćaj novca
            biće izvršen u roku od 14 dana od prijema vraćene robe.
          </p>
          <p data-id="element-1003">
            <strong data-id="element-1004">Napomena za pravna lica:</strong> Pravo na odustanak od
            ugovora u roku od 14 dana ne važi za pravna lica (B2B kupovina).
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1005">
            2. Reklamacije i saobraznost
          </h2>
          <p data-id="element-1006">
            Svi naši proizvodi podležu garanciji i pravilima o saobraznosti.
            Ukoliko primetite nedostatak ili kvar na uređaju, molimo vas da
            popunite formu za servis na našem sajtu ili nas kontaktirate na
            info@dtech.rs.
          </p>
          <p data-id="element-1007">
            Uz reklamaciju je neophodno dostaviti dokaz o kupovini (račun). Naš
            servisni tim će u najkraćem roku proceniti reklamaciju i obavestiti
            vas o daljim koracima (popravka, zamena ili povraćaj novca).
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1008">
            3. Oštećenja u transportu
          </h2>
          <p data-id="element-1009">
            Ukoliko je roba oštećena tokom transporta, potrebno je da oštećenje
            prijavite kuriru odmah po preuzimanju i da napravite zapisnik o
            oštećenju. Nakon toga, kontaktirajte nas kako bismo rešili problem u
            najkraćem roku.
          </p>
        </div>
      </div>
    </main>;
}